import { useState, useEffect } from "react";
import { motion } from "framer-motion";

const links = [
  { label: "Why PlayVerse", href: "#why" },
  { label: "Systems", href: "#systems" },
  { label: "By the Numbers", href: "#numbers" },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <motion.header
      data-testid="main-navbar"
      initial={{ y: -80, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{ duration: 0.8, delay: 0.2, ease: [0.22, 1, 0.36, 1] }}
      className={`fixed top-0 left-0 right-0 z-50 transition-colors duration-500 ${
        scrolled ? "backdrop-blur-xl bg-black/60 border-b border-white/10" : "bg-transparent"
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-10 h-[72px] flex items-center justify-between">
        <a href="#top" data-testid="navbar-logo" className="flex items-center gap-3 group">
          <span className="font-heading text-xl tracking-tighter font-extrabold text-white">
            PLAY<span className="text-[#00D4FF]">VERSE</span>
          </span>
        </a>

        <nav className="hidden md:flex items-center gap-8">
          {links.map((l) => (
            <a
              key={l.href}
              href={l.href}
              data-testid={`nav-link-${l.label.toLowerCase().replace(/\s/g, "-")}`}
              className="font-mono-pv text-[11px] uppercase tracking-[0.2em] text-white/60 hover:text-[#00D4FF] transition-colors duration-300"
            >
              {l.label}
            </a>
          ))}
        </nav>

        <a
          href="#contact"
          data-testid="navbar-cta-quote"
          className="font-mono-pv text-[11px] uppercase tracking-[0.2em] px-5 py-2.5 rounded-full bg-[#007AFF] text-white hover:bg-[#00D4FF] hover:text-[#05050A] transition-colors duration-300 shadow-[0_0_24px_rgba(0,122,255,0.4)]"
        >
          Get Started
        </a>
      </div>
    </motion.header>
  );
}
